import { render, staticRenderFns } from "./BaseDeleteConfirm.vue?vue&type=template&id=14a8c981"
import script from "./BaseDeleteConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseDeleteConfirm.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports